import { render, staticRenderFns } from "./SellOutLateral.vue?vue&type=template&id=405637fb&lang=html&"
import script from "./SellOutLateral.vue?vue&type=script&lang=js&"
export * from "./SellOutLateral.vue?vue&type=script&lang=js&"
import style0 from "./SellOutLateral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/sell-out/SellOutLateral.vue
// module id = 1486
// module chunks = 28